import React from "react";
import { spring, useCurrentFrame, useVideoConfig, interpolate } from "remotion";

interface OutroProps {
  keywords: string[];
  frame: number;
  fps: number;
}

export const CinematicEpicOutro: React.FC<OutroProps> = ({
  keywords,
  frame,
  fps,
}) => {
  const { height } = useVideoConfig();

  // Entrance animations
  const textScale = spring({
    frame,
    fps,
    from: 0.88,
    to: 1.0,
    config: { damping: 14, mass: 0.5, stiffness: 100 },
  });

  const textOpacity = interpolate(frame, [0, 8], [0, 1], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  // Pulse animation for the CTA button
  const pulseScale = 1.0 + Math.sin((frame / fps) * Math.PI * 1.5) * 0.03;

  // Widescreen Letterbox heights
  const letterboxHeight = interpolate(frame, [0, 20], [height * 0.15, height * 0.12], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0,
        left: 0,
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      {/* Cinematic Widescreen Letterbox Bars */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: letterboxHeight,
          background: "linear-gradient(to bottom, #000000 70%, transparent 100%)",
          zIndex: 10,
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          height: letterboxHeight,
          background: "linear-gradient(to top, #000000 70%, transparent 100%)",
          zIndex: 10,
        }}
      />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          gap: "30px",
          width: "100%",
          padding: "0 40px",
          boxSizing: "border-box",
          transform: `scale(${textScale})`,
          opacity: textOpacity,
          zIndex: 5,
        }}
      >
        {/* Cinematic Label */}
        <div
          style={{
            fontFamily: "Space Grotesk, sans-serif",
            fontSize: "12px",
            fontWeight: 800,
            color: "#ff8c00",
            letterSpacing: "6px",
            textTransform: "uppercase",
            textShadow: "0 0 10px rgba(255,140,0,0.4)",
          }}
        >
          — SYSTEM READY —
        </div>

        {/* Cinematic Heading */}
        <h2
          style={{
            fontFamily: "Outfit, sans-serif",
            fontSize: "52px",
            fontWeight: 900,
            color: "#ffffff",
            lineHeight: 1.15,
            margin: 0,
            textTransform: "uppercase",
          }}
        >
          Stay Ahead of the Curve
        </h2>

        {/* Sub-label */}
        <p
          style={{
            fontFamily: "Space Grotesk, sans-serif",
            fontSize: "18px",
            fontWeight: 400,
            color: "rgba(255, 255, 255, 0.65)",
            margin: 0,
            maxWidth: "320px",
            lineHeight: 1.5,
          }}
        >
          Join our premium community to track tech shifts daily.
        </p>

        {/* Breathing Gold CTA Button */}
        <div
          style={{
            transform: `scale(${pulseScale})`,
            background: "linear-gradient(135deg, #ff8c00 0%, #ffb700 100%)",
            borderRadius: "6px",
            padding: "16px 48px",
            display: "flex",
            justifyContent: "center",
            boxShadow: "0 10px 25px rgba(255, 140, 0, 0.4)",
            cursor: "pointer",
            marginTop: "10px",
          }}
        >
          <span
            style={{
              fontFamily: "Space Grotesk, sans-serif",
              fontWeight: 800,
              fontSize: "20px",
              color: "#08080c",
              letterSpacing: "2.5px",
              textTransform: "uppercase",
            }}
          >
            🔔 SUBSCRIBE
          </span>
        </div>

        {/* Channels/Watermark */}
        <div
          style={{
            fontFamily: "Space Grotesk, sans-serif",
            fontWeight: 700,
            fontSize: "18px",
            color: "rgba(255, 255, 255, 0.4)",
            letterSpacing: "2px",
            marginTop: "15px",
          }}
        >
          {keywords?.[0] ? `@${keywords[0].replace("#", "")}` : "@AgenticNews"}
        </div>
      </div>
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
